import { SelectOptionType } from '../../../components/dialog/helper';
import { TimeZonePayload } from '../../../integrations/lavva/api/installation/installation.types';

export const mapTimeZonesToOptions = (
  data: TimeZonePayload[] | undefined,
  search: string,
): SelectOptionType<string>[] => {
  const options: SelectOptionType<string>[] = [];

  try {
    data
      ?.filter(
        (x) =>
          x.id.toLowerCase().includes(search.toLowerCase()) ||
          x.offsets[0].toLowerCase().includes(search.toLowerCase()),
      )
      .map((zone: TimeZonePayload) => {
        options.push({ label: `${zone.id} (GMT${zone.offsets[0]})`, value: zone.id });
      });

    return options;
  } catch {
    return options;
  }
};
